import React from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import CreateGroup from "./CreateGroup";
import { FormattedMessage } from "react-intl";

const CreateGroupModal = ({
  createGroupModal,
  setCreateGroupModal,
  handleSearchQuery,
  setAddUserModal,
}) => {
  return (
    <Modal
      isOpen={createGroupModal}
      heading={<FormattedMessage id="USERGROUP_ADDUSERLBL" />}
      toggle={() => {
        setCreateGroupModal(false);
      }}
      width={"47"}
    >
      <CreateGroup
        handleSearchQuery={handleSearchQuery}
        setCreateGroupModal={setCreateGroupModal}
        setAddUserModal={setAddUserModal}
      />
    </Modal>
  );
};

export default CreateGroupModal;
